var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import SearchField from "../../Form/SearchField";
import { AddressTypeSearch } from "../AddressType/AddressTypeSearch";
import CheckboxField from "../../Form/CheckboxField";
export const SSE_FORM_ADDRESS_QUESTION_GET_CRITERIA = (formState) => {
    return formState;
};
export const SSE_FORM_ADDRESS_QUESTION_GET_FORM_STATE = (formField) => __awaiter(void 0, void 0, void 0, function* () {
    return formField;
});
const SSEFormAddressQuestionForm = ({ makeName, }) => {
    return (_jsxs(_Fragment, { children: [_jsx(SearchField, { label: "Address Type", required: true, name: makeName("criteria.addressType"), as: (provided) => _jsx(AddressTypeSearch, Object.assign({}, provided)) }), _jsx(CheckboxField, { label: "Required", name: makeName("required") })] }));
};
export const AddressFormComponent = {
    form: SSEFormAddressQuestionForm,
    getCriteria: SSE_FORM_ADDRESS_QUESTION_GET_CRITERIA,
    getFormState: SSE_FORM_ADDRESS_QUESTION_GET_FORM_STATE,
};
